import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DoctorsModel } from 'src/app/models/DoctorsModel';
import { ReportFromToComponent } from '../report-from-to/report-from-to.component';
import { LocalStorageService } from 'ngx-webstorage';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-reportbooking',
  templateUrl: './reportbooking.component.html',
  styleUrls: ['./reportbooking.component.css']
})
export class ReportbookingComponent implements OnInit {
  ReportURL0 =  'CocReports/ReservationByDoctor';
  ReportURL1 =  'CocReports/ReservationByRoom';
  ReportURL11 =  'CocReports/ReservationByRoomType';
  ReportURL2 =  'CocReports/ReservationByPatient';
  ReportURL3 =  'CocReports/ReservationOA';

  PatientCode ='';
  docCode ='';
  fromDate='';
  toDate='';
  fromDateD = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  toDateD = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  screenTitle ='';

  roomCode = '1';
  roomName = '';
  roomtype = '';

  constructor(public route: Router,
    private dialogref: MatDialog,
    private prepHDSelecteData:DoctorsModel,
    public storage: LocalStorageService,
    public doctorSelectedData: DoctorsModel) { }

  ngOnInit(): void {
  }
  ReportReservation(){
    this.route.navigate(['report-vewier', this.ReportURL0]);
  }
  ReportReservationD(){
    this.route.navigate(['report-vewier', this.ReportURL1]);
  }
  ReportReservationP(){
    this.route.navigate(['report-vewier', this.ReportURL2]);
  }
  ReportReservationOA(){
    this.route.navigate(['report-vewier', this.ReportURL3]);
  }

  openDialog_1(){
    this.screenTitle ='Reservation by doctor from date to date';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_N-Doc_Y-Butt_Y-Room_N'}
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.docName;
        this.toDate = result.docTitle;
        this.fromDateD = result.docWMMobile;
        this.toDateD = result.docWmail;
        this.docCode = result.docCode;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgParD1', this.fromDateD);
        this.storage.store('stgParD2', this.toDateD);
        this.storage.store('stgParD3', this.docCode);

        console.log("stgParD1 ",this.storage.retrieve('stgParD2'));

        this.route.navigate(['report-vewier', this.ReportURL0]);

      });
  }

  openDialog_2(){
    this.screenTitle ='Reservation by treatment room from date to date';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_Y'}
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.docName;
        this.toDate = result.docTitle;
        this.fromDateD = result.docWMMobile;
        this.toDateD = result.docWmail;
        this.roomCode = result.docDepartment;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgParD1', this.fromDateD);
        this.storage.store('stgParD2', this.toDateD);
        this.storage.store('stgParD3', this.roomCode);

        this.route.navigate(['report-vewier', 'CocReports/ReservationByRoom']);

      });
  }
  openDialog_22(){
    this.screenTitle ='Reservation by room Type from date to date';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_Y-RoomType_Y'}
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.docName;
        this.toDate = result.docTitle;
        this.fromDateD = result.docWMMobile;
        this.toDateD = result.docWmail;
        this.roomtype = result.docmail;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgParD1', this.fromDateD);
        this.storage.store('stgParD2', this.toDateD);
        this.storage.store('stgParD3', this.roomtype);

        console.log("stgParD1 ",this.storage.retrieve('stgParD2'));

        this.route.navigate(['report-vewier', this.ReportURL11]);

      });
  }

  openDialog_3(){
    this.screenTitle ='Reservation Over All from date to date';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_N'}
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.docName;
        this.toDate = result.docTitle;
        this.fromDateD = result.docWMMobile;
        this.toDateD = result.docWmail;
        this.roomCode = result.docDepartment;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgParD1', this.fromDateD);
        this.storage.store('stgParD2', this.toDateD);


        console.log("stgParD1 ",this.storage.retrieve('stgParD2'));

        this.route.navigate(['report-vewier', this.ReportURL3]);

      });
  }

  openDialog_4(){
    this.screenTitle ='Reservation by patient from date to date';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_Y-Doc_N-Butt_N-Room_N'}
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.patientFName ;
        this.toDate = result.birthDate;
        this.fromDateD = result.telHome;
        this.toDateD = result.patientFullName;
        this.PatientCode = result.patientCode;
          console.log("docAddress ", this.fromDateD + "   result.patientFullName :" + result.patientFullName  );

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgParD1', this.fromDateD);
        this.storage.store('stgParD2', this.toDateD);
        this.storage.store('stgParD3', this.PatientCode);


        console.log("stgParD1 ",this.storage.retrieve('stgParD2'));

        this.route.navigate(['report-vewier', this.ReportURL2]);

      });
  }
}


